import { render, staticRenderFns } from "./delete-subpage.vue?vue&type=template&id=580fd016&lang=pug&"
import script from "./delete-subpage.vue?vue&type=script&lang=js&"
export * from "./delete-subpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports